// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chain-table-row .chain-name[data-v-6518f1e9]{font-family:Inter;font-size:.875rem;line-height:1;font-weight:600;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
